// components/common/Sidebar.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { usePermissions } from "../../context/PermissionContext";
import { PERMISSIONS } from "../../api/permissions";

const Sidebar = ({
  isOpen,
  onClose,
  activeMenu = "business",
  onMenuChange,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission } = usePermissions(); // ✅ FIX: destructure hasPermission

  const menuItems = [
    {
      id: "business",
      label: "Business",
      icon: "bi-building",
      path: "/business",
      permission: PERMISSIONS.BUSINESS_GET_RESELLER,
    },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "bi-speedometer2",
      path: "/dashboard",
      permission: PERMISSIONS.TRANSACTION_GET_SUMMARY_RESELLER,
    },
    {
      id: "transaction",
      label: "Transaction",
      icon: "bi-arrow-left-right",
      path: "/transaction",
      permission: PERMISSIONS.TRANSACTION_GET_RESELLER,
    },
  ];

  const visibleItems = menuItems.filter(
    (item) => !item.permission || hasPermission(item.permission),
  );

  const handleMenuClick = (item) => {
    navigate(item.path);
    if (onMenuChange) {
      onMenuChange(item.id);
    }
    if (onClose) {
      onClose();
    }
  };

  const getActiveMenu = () => {
    if (activeMenu) return activeMenu;
    const path = location.pathname;
    if (path === "/business" || path === "/") return "business";
    if (path === "/dashboard") return "dashboard";
    if (path === "/transaction") return "transaction";
    return "business";
  };

  const currentActive = getActiveMenu();

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}

      <div className={`sidebar ${isOpen ? "sidebar-open" : ""}`}>
        <div className="sidebar-header">
          <img
            src="/logo/Paynuts-logo-2026.png"
            alt="PayNuts Go"
            className="sidebar-logo"
          />
        </div>

        <div className="sidebar-menu">
          {visibleItems.map((item) => (
            <div
              key={item.id}
              className={`sidebar-menu-item ${currentActive === item.id ? "active" : ""}`}
              onClick={() => handleMenuClick(item)}
            >
              <i className={`bi ${item.icon} me-2`}></i>
              {item.label}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;